import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`
    :root {
        --font-display: "Sora", "Avenir Next", sans-serif;
        --font-body: "Manrope", "Segoe UI", sans-serif;
        --primary: #e15794;
        --primary-strong: #cb2f72;
        --accent: #ffc85c;
        --accent-soft: #fff4d0;
        --ink: #20133b;
        --ink-soft: #4e4763;
        --surface: rgba(255, 255, 255, 0.82);
        --surface-strong: #ffffff;
        --surface-soft: #fff8fb;
        --line: rgba(31, 23, 64, 0.1);
        --shadow-soft: 0 24px 60px rgba(31, 23, 64, 0.08);
        --shadow-strong: 0 34px 80px rgba(31, 23, 64, 0.14);
        --text-strong: var(--ink);
        --text-muted: #564f6b;
        --text-soft: #726b84;
    }

    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    html {
        scroll-behavior: smooth;
        overflow-x: hidden;
    }

    body {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        min-height: 100%;
        background:
            radial-gradient(circle at top left, rgba(255, 212, 228, 0.9) 0%, rgba(255, 212, 228, 0) 34%),
            radial-gradient(circle at 85% 15%, rgba(255, 236, 183, 0.82) 0%, rgba(255, 236, 183, 0) 26%),
            linear-gradient(180deg, #fff9fb 0%, #fffdf8 48%, #fff8fb 100%);
        color: var(--text-strong);
        font-family: var(--font-body);
        overflow-x: hidden;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    body::before {
        content: "";
        position: fixed;
        inset: 0;
        background-image:
            linear-gradient(rgba(255, 255, 255, 0.3) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255, 255, 255, 0.3) 1px, transparent 1px);
        background-size: 72px 72px;
        mask-image: radial-gradient(circle at center, black 12%, transparent 75%);
        pointer-events: none;
        opacity: 0.4;
        z-index: -2;
    }

    #root {
        min-height: 100vh;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: var(--font-display);
        color: var(--text-strong);
        font-weight: 700;
        line-height: 1.2;
        margin: 0;
        letter-spacing: -0.03em;
    }

    p {
        color: var(--text-muted);
        font-size: 1rem;
        line-height: 1.75;
        margin: 0;
    }

    h1 {
        font-size: clamp(2.7rem, 6vw, 4.75rem);
    }

    h2 {
        font-size: clamp(2rem, 4vw, 3.2rem);
    }

    h3 {
        font-size: clamp(1.4rem, 3vw, 2rem);
    }

    a {
        text-decoration: none;
        outline: none;
        color: var(--primary);
        transition: color 0.2s ease;

        &:hover {
            color: var(--primary-strong);
        }
    }

    strong {
        color: var(--text-strong);
    }

    ul,
    ol {
        padding-left: 1.25rem;
    }

    li {
        color: var(--text-muted);
    }

    img {
        max-width: 100%;
        height: auto;
        object-fit: contain;
    }

    button,
    input,
    textarea,
    select {
        font: inherit;
    }

    input,
    textarea {
        width: 100%;
        border-radius: 20px;
        border: 1px solid rgba(31, 23, 64, 0.12);
        background: rgba(255, 255, 255, 0.9);
        color: var(--text-strong);
        transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;
        outline: none;
        padding: 1rem 1.15rem;

        &::placeholder {
            color: #938ca3;
        }

        &:focus {
            border-color: rgba(225, 87, 148, 0.5);
            box-shadow: 0 0 0 5px rgba(225, 87, 148, 0.12);
        }
    }

    ::selection {
        background: rgba(225, 87, 148, 0.22);
        color: var(--text-strong);
    }

    :focus-visible {
        outline: 3px solid rgba(225, 87, 148, 0.28);
        outline-offset: 3px;
    }

    main {
        display: block;
    }
`;
